import "./index.scss";
import { GeneralMediumChevronUp } from "@wise-emotions/react-icons";
import { debounce } from "@wise-emotions/web-utils";
import IconWrap from "components/Icon/IconWrap";
import React, { useCallback, useEffect, useRef } from "react";

const SCROLL_VISIBLE_BTN_TO_TOP = 1200;
const CLASS_BTN_VISIBLE = "btn-back-to-top--visible";

const BtnBackToTop = () => {
  const btnBackToTop = useRef<HTMLButtonElement>(null);

  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const checkScrollTop = () => {
    if (btnBackToTop.current) {
      const btnBackToTopIsVisible =
        btnBackToTop.current.classList.contains(CLASS_BTN_VISIBLE);
      if (
        !btnBackToTopIsVisible &&
        window.pageYOffset > SCROLL_VISIBLE_BTN_TO_TOP
      ) {
        btnBackToTop.current.classList.add(CLASS_BTN_VISIBLE);
      } else if (
        btnBackToTopIsVisible &&
        window.pageYOffset < SCROLL_VISIBLE_BTN_TO_TOP
      ) {
        btnBackToTop.current.classList.remove(CLASS_BTN_VISIBLE);
      }
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fnCheckScrollTop = useCallback(debounce(checkScrollTop, 200), []);

  useEffect(() => {
    window.addEventListener("scroll", fnCheckScrollTop);

    return () => {
      window.removeEventListener("scroll", fnCheckScrollTop);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <button
      type="button"
      className="btn-back-to-top"
      onClick={backToTop}
      ref={btnBackToTop}
      // NOTE: static label for now
      aria-label="back to top"
    >
      <span className="btn-back-to-top__content">
        <IconWrap>
          <GeneralMediumChevronUp />
        </IconWrap>
      </span>
    </button>
  );
};

export default BtnBackToTop;
